
export default {
    name: 'LeeTagGroup',
    data() {
        return {
            tags: [],
            newtag: '',
            edit: false,
            err: false
        }
    },
    provide() {
        return {
            taggroup: this
        };
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus()
            }
        }
    },
    watch: {
        tag: {
            immediate: true,
            handler(value) {
                this.tags = value
            }
        }
    },
    mounted() {
        this.keyupEnter()
    },
    methods: {
        keyupEnter() {
            document.onkeydown = (e) => {
                let ipt = this.$refs.ipt
                if (e.keyCode === 13 && e.target === ipt) {
                    this.addtag()
                }
            }
        },
        addtag() {
            this.edit = false
            var newtag = this.newtag.replace(/\s*/g, "");
            if (newtag.length > 0) {
                var fi = this.tags.filter(function (el) {
                    return el.t.indexOf(newtag) > -1;
                });
                if (fi.length < 1) {
                    this.tags.push({t: newtag})
                } else {
                    this.err = true
                    setTimeout(() => {
                        this.err = false
                    }, 2000)
                }

            }
            this.newtag = ''

        }
    },
    props: {
        tag: {
            type: Array,
            default() {
                return []
            }
        },
        closeable: {
            type: Boolean,
            default: false //默认default
        },
        editable: {
            type: Boolean,
            default: false //默认default
        }
    }
};
